export default __webpack_public_path__ + "e1c73d93aaacb3ca148bc6b7c84401b4.svg";